import { useContext, useEffect, useState } from "react"
import AOS from 'aos';
import { AppContext } from "../App"
import { getInlineLoader } from "../Helpers";

import OneNews from "./OneNews";


export default function NewsBanner(props) {

  const appContext = useContext(AppContext);

  /* Place states here */
  const [ ready, setReady ] = useState(false);

  async function init() {
    setReady(false);
    await Promise.all([
      appContext.getAllNews(),
    ])
    setReady(true);
  }

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      offset: 100
    });
  }, []);

  

  if (ready) {
    return (
      <div 
        className="MainBodySection bg-background text-primary"
        style={{
          paddingTop: "80px",
          paddingBottom: "80px"
        }}
      >
        
        <div 
          className="container"
          
        >
          
      

          <div className="row">

            <div className="col-md-12 mb-5 text-center" data-aos="fade-up">
              <span 
                className="section-subtitle font-semi-bold mb-3 text-primary fs-3 text-uppercase"
                style={{ letterSpacing: "2px", fontSize: "0.9rem" }}
              >
                News & Updates
              </span>
              <h2 
                className="section-title font-bold"
                style={{ maxWidth: "800px", margin: "0 auto", fontWeight: "700" }}
              >
                Strategic Knowledge to Drive Your Business Growth
              </h2>
              <p className="text-muted mt-3" style={{ maxWidth: "600px", margin: "1rem auto" }}>
                Expert analysis and industry trends to keep your enterprise ahead of the curve.
              </p>
            </div>

            
            {
              (() => {
                const isHomePage = appContext.navItem === "" || appContext.navItem === "home";
                const displayedNews = isHomePage ? (appContext.allNews || []).slice(0, 3) : (appContext.allNews || []);
                
                if (displayedNews.length > 0) {
                  return displayedNews.map((item, i) => (
                    <div key={i} className="col-md-4 mb-4" data-aos="fade-up" data-aos-delay={i * 150}>
                      <OneNews data={item}/>
                    </div>
                  ));
                }
                return <div className="col-md-12 mb-1 mt-1 text-muted text-center"><h6>No recent updates available</h6></div>;
              })()
            }

            {/* View More Button for Home */}
            {
              (appContext.navItem === "" || appContext.navItem === "home") && (appContext.allNews || []).length > 3 && (
                <div className="col-md-12 mt-4 text-center" data-aos="fade-up" data-aos-delay="400">
                  <a 
                    onClick={() => appContext.navTo({item: 'news'})} 
                    className="btn btn-primary px-4 py-2 text-uppercase fw-semibold"
                    style={{ borderRadius: "4px", letterSpacing: "1px" }}
                  >
                    View All Insights <span className="ms-2">→</span>
                  </a>
                </div>
              )
            }

            
            
            
          </div>

          
        </div>
          
        
      </div>
    );
  } else {
    return (
      <div className="container mSupportLoading">
        {getInlineLoader()}
      </div>
    );
  }
}